import React, { useEffect, useState } from 'react';
import './intercom';
import { SnackbarProvider } from 'notistack';
import LiveChat from 'react-livechat';

// Store
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from './store';
import { getProfile } from './store/auth/asyncThunk';

// UI
import { MuiThemeProvider, CssBaseline } from '@material-ui/core';
import { theme } from 'src/materialConfig/theme';
import { FullSizeProgress } from './routing/RouteSuspense';
import './App.css';

import { SnackbarUtilsConfigurator } from './utils/snackbarUtil';
import { LocalStorageApi } from './api/localStorage';
import { IDLE_STATUS, LOADING_STATUS } from './utils/types/statuses';
import { AppRouter } from './routing/AppRouter';
import { APP_ROUTES } from 'src/routing/AppRoutes';
import { openLoginModal, closeLoginModal } from 'src/store/layout/slice';

const accessToken: string = LocalStorageApi.getAccessToken();
let savedChatRef: any;

const url = window.location.pathname;

const ANCHOR_ORIGIN = {
  vertical: 'bottom',
  horizontal: 'left',
};

const App: React.FC = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    if (accessToken) {
      dispatch(getProfile());
    }
  }, [dispatch]);
  const { user, requests } = useSelector((state: RootState) => state.auth);

  const isLoaderVisible = Boolean(
    !user &&
      accessToken &&
      (requests.getProfile.status === IDLE_STATUS ||
        requests.getProfile.status === LOADING_STATUS),
  );

  console.log('App mounted');

  
  const [liveChatRef, setLiveChat] = useState<any>(null);
  useEffect(() => {
    if (liveChatRef) {
       savedChatRef = liveChatRef;
    }
    if (savedChatRef && savedChatRef.open_chat_window) {
      savedChatRef?.minimize_chat_window();
    }
    return () => {
      if (savedChatRef && savedChatRef?.hide_chat_window) {
        // @ts-ignore
        savedChatRef?.hide_chat_window();
      }
    };
  }, [liveChatRef]);
  
    useEffect(() => {
		window.Intercom('boot', {
			app_id: 'tl53k1w1',
		});
  	}, []); 
	
	const [isLoggedIn, setIsLoggedIn] = useState(false);
	useEffect(() => {
		if(user) {
			setIsLoggedIn(true);
		}else {
			setIsLoggedIn(false);
		}
	}, [user]);
	
	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);
	const login = urlParams.get('login');
	if(login === 'true') {
		if(!isLoggedIn) {
			dispatch(openLoginModal("Journalist"));
		}else {
			dispatch(closeLoginModal("Journalist"));
		}
	}
  
  return (
    <>
      <CssBaseline />
      <MuiThemeProvider theme={theme}>
        <SnackbarProvider maxSnack={3} anchorOrigin={ANCHOR_ORIGIN}>
          <SnackbarUtilsConfigurator />
          {isLoaderVisible ? <FullSizeProgress /> : <AppRouter />}
        </SnackbarProvider>
        
		{url !== APP_ROUTES.SURVEY_FORM ? 
			<LiveChat
			  license={8148181}
			  onChatLoaded={(ref: any) => {
				setLiveChat(ref);
			  }}
			/> : ''}
      </MuiThemeProvider>
    </>
  );
};

export default App;
